export default function PHP_MySQLInsert() {
  return (
    <div>
      <h1>PHP_MySQLInsert</h1>
    </div>
  );
}
